// Utilities
import * as React from "react";
/** String used for data- attribute for Landmark */ export const LANDMARK_ATTR = "data-landmark";
/**
 * Landmark component for accessibility navigation.
 * Provides semantic structure for screen readers and keyboard navigation.
 */ export const Landmark = (props)=>{
    const attrs = {
        [LANDMARK_ATTR]: true
    };
    return /*#__PURE__*/ React.createElement("div", {
        ...attrs,
        ...props
    }, props.children);
};
